import React from 'react';
import { Box } from '@drone-js/core';
import { Activity } from 'gql/autogen/Activity';
import { Offer } from 'gql/autogen/Offer';
import { Loader } from 'component/common/Loader/Loader';
import NoAvailableOption from 'component/page/detail/PackageOptions/NoAvailableOption/NoAvailableOption';
import PackageOptionCard from 'component/page/detail/PackageOptions/PackageOptionContainer/PackageOption';
import { getValidOffers } from 'component/page/detail/PackageOptions/PackageOptionsUtils';

export interface OwnProps {
    activity?: Activity;
    isLoading: boolean;
    isLoaded: boolean;
}

const PackageOptionContainer: React.FC<OwnProps> = (props) => {
    // We need to keep the previous offers to keep displaying the card when Redux store is cleared for new fetch
    const [prevOffers, setPrevOffers] = React.useState<Offer[]>([]);
    const { activity } = props;
    const actualOffers = React.useMemo(() => activity?.offerPricing?.offers || [], [activity]);
    const isNoPrevOffers = prevOffers.length <= 0;
    const isShowLoader = isNoPrevOffers && (!props.isLoaded || props.isLoading);

    React.useEffect(() => {
        if (!props.isLoading) {
            setPrevOffers(actualOffers);
        }
    }, [actualOffers, props.isLoading]);

    if (isShowLoader) {
        return (
            <Box m="auto">
                <Loader element="package-option-card-container" />
            </Box>
        );
    }

    if (!prevOffers || prevOffers.length === 0) {
        return <NoAvailableOption />;
    }

    const { validAvailableOffers, validUnavailableOffers } = getValidOffers(prevOffers);
    const allValidOffers = [...validAvailableOffers, ...validUnavailableOffers];

    if (validAvailableOffers.length === 0 && validUnavailableOffers.length === 0) {
        return <NoAvailableOption />;
    }

    return <PackageOptionCard offers={allValidOffers} supplier={activity?.masterSupplierId || -1} />;
};
PackageOptionContainer.displayName = 'PackageOptionContainer';

export default PackageOptionContainer;
